import { Injectable } from '@angular/core';
import { AngularFirestore, DocumentChangeAction, QueryFn, Action, DocumentSnapshot } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FirestoreReference } from 'src/app/Classes/firestoreReference/firestore-reference';

@Injectable({
  providedIn: 'root'
})
export class FirestoreHandlerService {
  constructor(private db: AngularFirestore) { }

  writeDoc(col: string, data: any, id?: string) {
    const dataToWrite: Object = Object.assign({}, data);
    const collection = this.db.collection(col);
    if (id) {
      return collection.doc(id).set(dataToWrite).then(() => id);
    } else {
      return collection.add(dataToWrite).then(ref => ref.id);
    }
  }

  getAll<T>(path: string, where?: QueryFn): Observable<FirestoreReference<T>[]> {
    console.log("-- querying db for ", path);
    const createReferences = (changes: DocumentChangeAction<T>[]) =>
      changes.map(change => ({
        id: change.payload.doc.id,
        data: change.payload.doc.data() as T,
        path: change.payload.doc.ref.path
      }));
    const toObservable = map(createReferences);

    return this.db.collection<T>(path, where)
      .snapshotChanges()
      .pipe(toObservable);
  }

  getDoc<T>(path: string): Observable<FirestoreReference<T>> {
    console.log("-- querying db for");
    const createReference = (change: Action<DocumentSnapshot<T>>) => ({
      id: change.payload.id,
      data: change.payload.data() as T,
      path: change.payload.ref.path
    });

    const toObservable = map(createReference);

    return this.db.doc<T>(path)
      .snapshotChanges()
      .pipe(toObservable);
  }

  batchWrite<T>(colPath: string, data: T[]) {
    const MAXBATCHSIZE = 250;
    let result: firebase.firestore.WriteBatch[] = [];
    const batches = data.reduce((batches, datum: T, index) => {
      if (index % MAXBATCHSIZE === 0) {
        batches.push(this.db.firestore.batch());
      }
      const currentBatch = batches[batches.length - 1];
      const col = this.db.firestore.collection(colPath);
      const dataToWrite = Object.assign({}, datum);
      currentBatch.set(col.doc(), dataToWrite);
      return batches;
    }, result);

    return batches.reduce((previousPromise: Promise<void>, batch) =>
      previousPromise.then(_ => batch.commit())
      , Promise.resolve())
  }

}
